import { QueueStore } from '../store/queue-store';
import type { UnitQueueRowData } from '../../socket/stream-types';

export class QueueRegistry {
    private queueStores: Set<QueueStore> = new Set<QueueStore>();
    public addQueueStore(queueStore: QueueStore): void {
        this.queueStores.add(queueStore);
    }
    public removeQueueStore(queueStore: QueueStore): void {
        this.queueStores.delete(queueStore);
    }
    public getUnitQueueStores(): QueueStore<UnitQueueRowData>[] {
        const unitQueueStores: QueueStore<UnitQueueRowData>[] = [];
        for (const queueStore of this.queueStores.values()) {
            if (queueStore.workspacePanel.queue.dataEntityType === 'UNIT') {
                unitQueueStores.push(queueStore as QueueStore<UnitQueueRowData>);
            }
        }
        return unitQueueStores;
    }
}
